// extracted by mini-css-extract-plugin
export default {"t":"style_t__rXomO","s":"style_s__5N9r7","s2":"style_s2__IvR15"};